export const cutEmail = (email: string, maxLength: number = 29) => {
  if (!email) {
    return ''
  }

  if (email.length > maxLength) {
    const lastCount = email.indexOf('@')
    const endPart = email.slice(lastCount, email.length)
    const startPart = maxLength - endPart.length
    return email.substring(0, startPart + 1) + '...' + endPart
  }

  return email
}
